goog.provide('yext.location.EntityLabels');
goog.provide('yext.location.EntityLabelsModel');

goog.require('yext');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * Data Model for the labels field.
 *
 * @param {!Object} data Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.location.EntityLabelsModel = function(data) {
  this.allOptions = this.createLabels(data.allOptions);
  this.selectedOptions = this.createLabels(data.selectedOptions);
  this.timestamp = data.timestamp;
  this.elidedModeLabelCount = data.elidedModeLabelCount;
};

/**
* Label Model
*
* @constructor
*
* @param {!Object} object with label fields
*/
yext.location.EntityLabelsModel.Label = function(data) {
  this.value = data.value;
  this.id = data.id;
  this.indeterminate = data.indeterminate;
  this.internal = data.internal;
  this.selected = true;
};

/**
* Set all the options for this field.
*
* @param {list} options The target list of options
*/
yext.location.EntityLabelsModel.prototype.createLabels = function(options) {
  var labels = [];
  if (Array.isArray(options)) {
    options.forEach(function(option) {
      labels.push(new yext.location.EntityLabelsModel.Label(option));
    });
  }
  return labels;
};

/**
* Set all the options for this field.
*
* @param {list} options The target list of options
*/
yext.location.EntityLabelsModel.prototype.setAllOptions = function(allOptions) {
  if (Array.isArray(allOptions)) {
    this.allOptions = allOptions.slice();
  }
};

/**
* Set all the selected options for this field.
*
* @param {list} options The target list of options
*/
yext.location.EntityLabelsModel.prototype.setSelectedOptions = function(selectedOptions) {
  if (Array.isArray(selectedOptions)) {
    this.selectedOptions = this.createLabels(selectedOptions.slice());
  }
};

/**
 * Set the timestamp for this field.
 *
 * @param {string} timestamp The target value
 */
yext.location.EntityLabelsModel.prototype.setTimestamp = function(timestamp) {
  if (yext.isString(timestamp)) {
    this.timestamp = timestamp;
  }
};

/**
 * Set the elidedModeLabelCount for this field.
 *
 * @param {string} elidedModeLabelCount The target value
 */
yext.location.EntityLabelsModel.prototype.setElidedModeLabelCount = function(elidedModeLabelCount) {
  if (yext.isNumber(elidedModeLabelCount)) {
    this.elidedModeLabelCount = elidedModeLabelCount;
  }
};

/**
 * Merges the indeterminate options with selected options
 */
yext.location.EntityLabelsModel.prototype.getSelectedOptions = function() {
  return this.selectedOptions.filter(function(option) {
    return option.selected;
  });
};

/**
 * Get the current state of the field as a JSON object
 */
yext.location.EntityLabelsModel.prototype.getJSONData = function() {
  return {
    'allOptions': this.allOptions,
    'selectedOptions': this.getSelectedOptions(),
    'elidedModeLabelCount': this.elidedModeLabelCount,
    'timestamp': this.timestamp,
  };
};

/**
 * Selects a label given its value. If no label with the specified value exists, a new label is created.
 *
 * @param {string}  value  The label's value
 */
yext.location.EntityLabelsModel.prototype.selectLabel = function(value) {
  var label = this.find(this.allOptions, value);
  var updated = false;

  if (!label) {
    label = {
      value: value,
      indeterminate: false,
    };
    this.allOptions.push(label);
    updated = true;
  } else if (this.findLabelIndex(this.selectedOptions, label.value) == -1) {
    // NOTE(schakraborty): This case occurs when the label is not already selected
    updated = true;
  }

  if (updated) {
    label.selected = true;
    this.selectedOptions.push(label);
    this.emitUpdate();
  } else if (label && this.findLabelIndex(this.selectedOptions, label.value) != -1) {
    /**
     * NOTE(schakraborty): This case takes care of the edge case when we are
     * in bulk edit mode and we try to add a label (through the label searcher)
     * that is already present in the initial label selection (selectedOptions).
     */
    var option = this.getOption(label.id);
    if (!option.selected) {
      this.setOptionSelected(option, true);
    }
  }
};

/**
 * Deselects a label given its value. If the label is a newly-created one (without an id), it is
 * removed from the label collection.
 *
 * @param {string} value The label's value
 */
yext.location.EntityLabelsModel.prototype.deselectLabel = function(value) {
  var label = this.find(this.allOptions, value);
  if (label) {
    var selectedLabelIndex = this.findLabelIndex(this.selectedOptions, label.value);
    if (!label.id) {
      this.allOptions.splice(this.allOptions.indexOf(label), 1);
    }
    if (selectedLabelIndex != -1) {
      this.selectedOptions.splice(selectedLabelIndex, 1);
    }

    if (!label.id || selectedLabelIndex != -1) {
      this.emitUpdate();
    }
  }
};

/**
 * Finds the label index in array.
 * @param {list} options The list to find the value in
 * @param {string} value The value to find the index of
 */
yext.location.EntityLabelsModel.prototype.findLabelIndex = function(options, value) {
  for (var i = 0; i < options.length; i++) {
    if (options[i].value == value) {
      return i;
    }
  }
  return -1;
};

/**
 * Finds the label with the specified value.
 *
 * @param   {string}  value  The label's value
 * @return  {!Object}        The label, if it exists
 */
yext.location.EntityLabelsModel.prototype.find = function(options, value) {
  var index = this.findLabelIndex(options, value);
  if (index != -1) {
    return options[index];
  }
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.location.EntityLabelsModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Get difference betweem two arrays. Return array of values(strings).
 *
 * @param   {list}  primList  The first list of objects.
 * @param   {list}  secList  The second list of objects.
 */
yext.location.EntityLabelsModel.prototype.arrayDiff = function(primList, secList) {
  var primValueList = primList.map(function(option) {
    return option.value;
  });
  var secValueList = secList.map(function(option) {
    return option.value;
  });

  return primValueList.filter(function(val) {
    return secValueList.indexOf(val) < 0;
  });
};

/**
 * Update the labels model
 *
 * @param {!Object} data information to fill in a labels model.
 */
yext.location.EntityLabelsModel.prototype.update = function(data) {
  this.setAllOptions(data.allOptions);
  this.setSelectedOptions(data.selectedOptions);
  this.setTimestamp(data.timestamp);
  this.setElidedModeLabelCount(data.elidedModeLabelCount);
  this.emitUpdate();
};

/**
 * Sorts list of labels
 *
 * @param List{!Object} labels list of labels to be sorted.
 */
yext.location.EntityLabelsModel.prototype.sort = function(labels) {
  labels.sort(function(a, b) {
    return a.value.localeCompare(b.value, {sensitivity: 'base'});
  });
  return labels;
};

/**
 * Wrapper for sorting labels
 */
yext.location.EntityLabelsModel.prototype.sortLabels = function() {
  this.sort(this.allOptions);
  this.sort(this.selectedOptions);
};

/**
 * Get a option by value
 *
 * @param {OptionListModel.Option}
 */
yext.location.EntityLabelsModel.prototype.getOption = function(value) {
  var self = this;
  for (var i = 0; i < this.selectedOptions.length; i++) {
    if (this.selectedOptions[i].id == value) {
      return this.selectedOptions[i];
    }
  }
};

/**
 * Update a indeterminate label in the model
 *
 * @param {EntityLabelsModel.Option}
 */
yext.location.EntityLabelsModel.prototype.setOptionSelected = function(option, selected) {
  var self = this;
  if (option != null) {
    option.selected = selected;
    option.indeterminate = false;
    this.emitUpdate();
  }
};

/**
 * Models a entity labels field.
 *
 * @param {!jQuery} $ctx Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.location.EntityLabels = function($ctx) {
  this.$ctx = $ctx;
  this.$entityLabels = $ctx.find('.js-labels-edit').addBack().filter('.js-labels-edit');
  this.$fieldValue = $ctx.find('.js-field-value');
  this.$display = $ctx.closest('.field-display');
  this.$labelSearcher = $ctx.find('.js-label-searcher');
  this.showInternalLabels = this.$entityLabels.data('showInternalLabels');
  this.$labelList = $ctx.find('.js-label-list');
  this.$elidedModeContainer = this.$ctx.find('.js-elided-mode-container');

  this.buildModel();
  this.storeValue();
  this.searcher();
  this.setFieldValue();
  this.bindElidedMode();
  this.bindUpdates();
};

/**
 * Constructs the label searcher.
 */
yext.location.EntityLabels.prototype.isIndeterminate = function() {
  for (var i = 0; i < this.model.selectedOptions.length; i++) {
    if (this.model.selectedOptions[i].indeterminate) {
      return true;
    }
  }
  return false;
};

/**
 * Bind the elided mode interaction
 */
yext.location.EntityLabels.prototype.bindElidedMode = function() {
  var self = this;
  this.$elidedModeContainer.find('.js-elided-mode-delete').click(function() {
    self.model.elidedModeLabelCount = undefined;
    self.onUpdate();
  });
};

/**
 * When any updates are made to the field, this method is called
 */
yext.location.EntityLabels.prototype.onUpdate = function() {
  this.emitUpdate();
  this.setFieldValue();
  this.render();
};

/**
 * Constructs the label searcher.
 */
yext.location.EntityLabels.prototype.searcher = function() {
  var self = this;
  var model = self.model;
  var searchLabels;
  var search = function(term) {
    searchLabels = self.model.arrayDiff(model.allOptions, model.selectedOptions);
    term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    var re = new RegExp(term, 'i');
    return searchLabels.filter(function(value) {
      return value.search(re) !== -1;
    })
      .map(function(value) {
        return {
          label: self.printLabel(value),
          value: value,
        };
      });
  };

  this.$labelSearcher.tagsInput({
    // TODO(schakraborty): In future, might have to pull of create new tags permission of initial json.
    createNewTags: true,
    customClass: 'badge-label',
    autocomplete: {
      source: function(request, response) {
        response(search(request.term));
      },
    },
    defaultText: self.isIndeterminate() ? yext.msg('Add more labels here') : yext.msg('Add labels'),
    placeholderColor: '#a9a9a4',
    onAddTag: function(value) {
      model.selectLabel(value);
    },
    onRemoveTag: function(value) {
      model.deselectLabel(value);
    },
    formatValue: function(value) {
      return self.printLabel(value);
    },
  });

  self.render();
};

/**
 * Renders the field in its current state
 */
yext.location.EntityLabels.prototype.render = function() {
  var stringValue = '';

  this.$elidedModeContainer.toggle(!!this.model.elidedModeLabelCount);
  this.$elidedModeContainer.find('.js-elided-mode-message')
    .html(this.renderElidedModeMessage());

  if (!this.isIndeterminate()) {
    stringValue = this.getFilteredSelectedOptions().map(function(o) {
      return o.value;
    }).join(',');
  }
  this.$labelSearcher.importTags(stringValue);

  this.$labelList.toggle(this.isIndeterminate() && !this.isElidedMode());
  if (this.isIndeterminate() && !this.isElidedMode()) {
    var labels = {};
    var self = this;

    this.model.selectedOptions.forEach(function(option) {
      labels[option.id] = option;
    });

    this.$labelList.find('input').each(function() {
      var $this = $(this);
      $this.prop({
        checked: labels[$this.val()].selected,
        indeterminate: labels[$this.val()].indeterminate,
      });
    });
  }
};

/**
 * Return the correct I18n pluralization if elided mode, or empty
 */
yext.location.EntityLabels.prototype.renderElidedModeMessage = function() {
  if (this.model.elidedModeLabelCount) {
    return yext.msgn('1 Label', '{0} Labels', this.model.elidedModeLabelCount);
  }
  return '';
};

/**
 * Filters selected options based on the showInternalLabels flag and if the options
 * are internal or not.
*/
yext.location.EntityLabels.prototype.getFilteredSelectedOptions = function() {
  var labels = this.model.selectedOptions;
  if (!this.showInternalLabels) {
    return labels.filter(function(o) {
      return !o.internal;
    });
  }
  return labels;
};

/**
 * Prints a label.
 *
 * @param string value to be changed into print format.
 */
yext.location.EntityLabels.prototype.printLabel = function(value) {
  var label = this.model.find(this.model.allOptions, value);
  if (!label) {
    return value;
  }
  var text = label.value;
  if (label.internal) {
    text += ' *';
  }
  return text;
};

/**
 * Bind to the update events from the labels model.
 */
yext.location.EntityLabels.prototype.bindUpdates = function() {
  var self = this;

  this.$labelList.on('click', 'input[type=checkbox]', function() {
    var $this = $(this);
    var option = self.model.getOption($this.val());
    self.model.setOptionSelected(option, option.indeterminate ? true : $this.is(':checked'));
    $this.prop({
      checked: option.selected,
      indeterminate: false,
    });
  });

  $(this.model).on('updated', function() {
    self.setFieldValue();
    self.emitUpdate();
  });
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.location.EntityLabels.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Builds labels model from DOM and generates options.
 */
yext.location.EntityLabels.prototype.buildModel = function() {
  var data = this.$entityLabels.data('value');
  this.model = new yext.location.EntityLabelsModel(data);
};

/**
 * Store the value so that it can be restored later
 */
yext.location.EntityLabels.prototype.storeValue = function() {
  this.storedValue = new yext.location.EntityLabelsModel(this.model);
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.EntityLabels.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.model.getJSONData()));
};

/**
 * Reset the field to the stored state
 */
yext.location.EntityLabels.prototype.reset = function() {
  this.set(this.storedValue);
};

/**
 * Set the labels model data and trigger a change event
 *
 * @param {!Object} data information to fill in a labels model.
 */
yext.location.EntityLabels.prototype.set = function(data) {
  this.model.update(data);
  this.model.sortLabels();
  this.$labelList.empty().append(this.createLabelOptions());
  this.render();
};

/**
 * Get the display value of the field (view mode)
 */
yext.location.EntityLabels.prototype.getDisplayValue = function() {
  var self = this;
  if (this.isElidedMode()) {
    return this.renderElidedModeMessage();
  } else if (this.isIndeterminate()) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    var labelDisplay = '';
    this.model.selectedOptions.forEach(function(label) {
      if (self.showInternalLabels && label.internal) {
        labelDisplay += self.formatLabel(label.value + ' *');
      } else if (!label.internal) {
        labelDisplay += self.formatLabel(label.value);
      }
    });
    return labelDisplay;
  }
};

/**
 * Return true if there is a elidedModeLabelCount
 */
yext.location.EntityLabels.prototype.isElidedMode = function() {
  return this.model.elidedModeLabelCount != undefined;
};

/**
 * Check if display should be empty
 */
yext.location.EntityLabels.prototype.isEmpty = function() {
  return this.getFilteredSelectedOptions().length === 0 && !this.isElidedMode();
};

/**
 * Formats label
 *
 * @param String value display value for the label.
 */
yext.location.EntityLabels.prototype.formatLabel = function(value) {
  return '<span class="badge-label label-view">' + value + '</span>';
};

/**
 * Formats option list
 *
 * @param list of labels
 */
yext.location.EntityLabels.prototype.createLabelOptions = function() {
  var items = [];
  this.model.selectedOptions.forEach(function(label) {
    var $li = $('<li/>');
    var $label = $('<label/>');

    var $inputLabel = $('<input/>', {
      type: 'checkbox',
      value: label.id,
      label: label.value,
    });
    $label.append($inputLabel);
    $label.append(label.value);
    $li.append($label);
    items.push($li);
  });
  return items;
};
